/**
 * Single shortcut row for the help dialog — extracted to dodge the Babel
 * visual-edits plugin's nested-map crash (Maximum call stack size exceeded).
 *
 * See `ShortcutsHelpDialog.js` for usage.
 */
import React from 'react';

const ShortcutRow = ({ label, keys, idx }) => (
  <li className="flex items-center justify-between py-2.5" data-testid={`shortcut-row-${idx}`}>
    <span className="text-sm text-slate-700">{label}</span>
    <span className="flex items-center gap-1">
      {keys.map((k, i) => (
        <kbd
          key={i}
          className="px-1.5 py-0.5 text-xs font-mono rounded border border-slate-200 bg-slate-50 text-slate-700 shadow-sm"
        >
          {k}
        </kbd>
      ))}
    </span>
  </li>
);

export default ShortcutRow;
